import React from 'react';
import { comparisonData } from '../data/mockData';
import { Check, X } from 'lucide-react';

const ComparisonSection = () => {
  return (
    <section data-testid="comparison-section" className="py-24 md:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">The Difference</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-5">
            Us vs. Traditional Firms vs. DIY
          </h2>
          <p className="text-base text-[#4B5563] leading-relaxed">
            See exactly what you get and what you save when you work with Trademark Logo Design.
          </p>
        </div>

        <div className="max-w-4xl overflow-x-auto">
          <table data-testid="comparison-table" className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-[#0A0F1C]">
                <th className="text-left py-4 pr-6 text-sm font-bold text-[#0A0F1C] uppercase tracking-wider">Feature</th>
                <th className="text-center py-4 px-4">
                  <span className="inline-block bg-[#002FA7] text-white px-4 py-1.5 text-xs font-medium uppercase tracking-wider">Us</span>
                </th>
                <th className="text-center py-4 px-4 text-xs font-bold text-[#4B5563] uppercase tracking-wider">Traditional Firm</th>
                <th className="text-center py-4 px-4 text-xs font-bold text-[#4B5563] uppercase tracking-wider">DIY</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, i) => (
                <tr key={i} data-testid={`comparison-row-${i}`} className="border-b border-[#E5E7EB] group hover:bg-white transition-colors duration-300">
                  <td className="py-4 pr-6 text-sm font-medium text-[#0A0F1C]">{row.feature}</td>
                  <td className="py-4 px-4 text-center">
                    {typeof row.us === 'boolean' ? (
                      row.us ? <Check className="w-5 h-5 text-[#002FA7] mx-auto" /> : <X className="w-5 h-5 text-gray-300 mx-auto" />
                    ) : (
                      <span className="text-sm font-bold text-[#002FA7]">{row.us}</span>
                    )}
                  </td>
                  <td className="py-4 px-4 text-center">
                    {typeof row.traditional === 'boolean' ? (
                      row.traditional ? <Check className="w-5 h-5 text-[#4B5563] mx-auto" /> : <X className="w-5 h-5 text-gray-300 mx-auto" />
                    ) : (
                      <span className="text-sm font-medium text-[#4B5563]">{row.traditional}</span>
                    )}
                  </td>
                  <td className="py-4 px-4 text-center">
                    {typeof row.diy === 'boolean' ? (
                      row.diy ? <Check className="w-5 h-5 text-[#4B5563] mx-auto" /> : <X className="w-5 h-5 text-gray-300 mx-auto" />
                    ) : (
                      <span className="text-sm font-medium text-[#4B5563]">{row.diy}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
